<script>
  import { onMount } from 'svelte';
  import * as d3 from 'd3';
  import { gen_header, gen_background, set_view_size, gen_skeleton_range_selection } from './SeparateView.js'
  
  // Export let name
  let SeparateView = undefined
  let benignView = undefined
  let benign_header = undefined
  let benign_background = undefined
  let benign_skeleton = undefined
  let attackedView = undefined
  let attacked_header = undefined
  let attacked_background = undefined
  let attacked_skeleton = undefined

  // TODO: Get predicted label of input
  // let benign_label = 'Lunges'
  // let attacked_label = 'excercising with an exercise ball'
  let benign_label = 'Lunges'
  let attacked_label = 'Swing'

  // Generate separate view
  onMount(async() => {
    gen_benign_view()
    gen_attacked_view()
    gen_skeleton_range_selection()
  })

  // Generate benign view
  function gen_benign_view() {

    // Benign view components
    benignView = d3.select(SeparateView).select('#benign-view')
    benign_header = benignView.select('.pose-view-header')
    benign_background = benignView.select('.pose-view-bg')
    benign_skeleton = benignView.select('.pose-view-skeleton')

    // Generate header 
    gen_header(benign_header, 'benign', benign_label)

    // Add background video
    gen_background(benign_background, benign_header, 'benign')
    
    // Set overlap view size
    set_view_size(benign_header, 'benign')

  }

  // Generate attacked view
  function gen_attacked_view() {

    // Attacked view components
    attackedView = d3.select(SeparateView).select('#attacked-view')
    attacked_header = attackedView.select('.pose-view-header')
    attacked_background = attackedView.select('.pose-view-bg')
    attacked_skeleton = attackedView.select('.pose-view-skeleton')

    // Generate header 
    gen_header(attacked_header, 'attacked', attacked_label)

    // Add background video
    gen_background(attacked_background, attacked_header, 'attacked')
    
    // Set overlap view size
    set_view_size(attacked_header, 'attacked')

  }

</script>

<style>

  #separate-view {
    text-align: left;
    margin: 10px;
    display: inline-block;
    flex-direction: column;
  }

  .pose-view-header {
    font-size: 16px;
  }

  .pose-view-header-rect {
    fill: 'black';
    height: 2rem;
    width: 10px;
    rx: 5px;
    ry: 5px;
  }

  .skeleton-range-selection-option {
    padding-top: 10px;
  }

  .skeleton-range-selection-option-component {
    display: inline-block;
  }

  .skeleton-range-selection-text {
    font-size: 14px;
    transform: translate(0px, -1px);
  }
</style>

<div id='separate-view' class='pose-view' bind:this={SeparateView}>

  <!-- Benign view -->
  <div id='benign-view' class='pose-view'>
    <svg id='benign-view-svg' class='pose-view-svg'>
      <g id='benign-view-header' class='pose-view-header'>
        <rect id='benign-view-header-rect' class='pose-view-header-rect'></rect>
      </g>
      <g id='benign-view-bg' class='pose-view-bg'></g>
      <g id='benign-view-skeleton' class='pose-view-skeleton'></g>
    </svg>
  </div>

  <!-- Attacked view -->
  <div id='attacked-view' class='pose-view'>
    <svg id='attacked-view-svg' class='pose-view-svg'>
      <g id='attacked-view-header' class='pose-view-header'>
        <rect id='attacked-view-header-rect' class='pose-view-header-rect'></rect>
      </g>
      <g id='attacked-view-bg' class='pose-view-bg'></g>
      <g id='attacked-view-skeleton' class='pose-view-skeleton'></g>
    </svg>
  </div> 

  <!-- Skeleton range selection view -->
  <div id='skeleton-range-selection-view'>
    <div id='skeleton-one-frame' class='skeleton-range-selection-option'>
      <div id='skeleton-one-frame-icon' class='skeleton-range-selection-option-component'></div>
      <div id='skeleton-one-frame-text' class='skeleton-range-selection-option-component skeleton-range-selection-text'></div>
    </div>
    <div id='skeleton-frame-range' class='skeleton-range-selection-option'>
      <div id='skeleton-frame-range-icon' class='skeleton-range-selection-option-component'></div>
      <div id='skeleton-frame-range-text' class='skeleton-range-selection-option-component skeleton-range-selection-text'></div>
    </div>
  </div>
</div> 

